export const getChoices = (items) => Object.values(items).map((item) => item);
